var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'html-module ' + _vm.config.className.value,domProps:{"innerHTML":_vm._s(_vm.config.html.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }